/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'navigation.global-shortcuts.all-sites': 'Alle Sites',
  'navigation.global-shortcuts.apps.align': 'Align',
  'navigation.global-shortcuts.apps.analytics': 'Analysen',
  'navigation.global-shortcuts.apps.assets': 'Assets',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Unternehmens-Hub',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'Ziele',
  'navigation.global-shortcuts.apps.home': 'Startseite',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Projekte',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Teams',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Schließen',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name}-Site',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(derzeit nicht verfügbar)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Symbol: externen Link öffnen',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(wird geladen)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(wird geladen)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'Menü öffnen',
  'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
  'navigation.global-shortcuts.sites': '{productName} Sites',
};
